module.exports = __webpack_public_path__ + "img/new_beijing.4cfc88f4.png";